import { Mfl } from '@deqo/mfl-js';
import { Mql } from '@deqo/mql-js';
import { component, Component, Convention, property } from '../../../concepts/objects';
import { JsonType } from '../../../concepts/objects/JsonType';
import { memoUsing } from '../../../concepts/objects/MemoUsing';

export interface ComputeItem extends Component {
    name: string;
}

export const ComputeItem = new Convention<ComputeItem>('ComputeItem');

const queryComputeItemDef = {
    name: 'QueryComputeItem',
    implements: [ComputeItem]
};

@component(queryComputeItemDef)
export class QueryComputeItem extends Component implements ComputeItem {

    @property({ type: 'string' })
    public name: string;

    @property({ type: 'string' })
    public code: string;

    @memoUsing('code')
    public get compiledCode() {
        try {
            return Mql.compile(this.code);
        }
        catch {
            return null;
        }
    }
}

const formulaComputeItemDef = {
    name: 'FormulaComputeItem',
    implements: [ComputeItem]
};

@component(formulaComputeItemDef)
export class FormulaComputeItem extends Component implements ComputeItem {

    @property({ type: 'string' })
    public name: string;

    @property({ type: 'string' })
    public code: string;

    @memoUsing('code')
    public get compiledCode() {
        try {
            return Mfl.compile(this.code);
        }
        catch {
            return null;
        }
    }
}

const actionComputeItemDef = {
    name: 'ActionComputeItem',
    implements: [ComputeItem]
};

@component(actionComputeItemDef)
export class ActionComputeItem extends Component implements ComputeItem {

    @property({ type: 'string' })
    public name: string;

    @property({ type: 'string' })
    public command: string;

    @property({ type: JsonType })
    public settings: any[];
}

const assertComputeItemDef = {
    name: 'AssertComputeItem',
    implements: [ComputeItem]
};

@component(assertComputeItemDef)
export class AssertComputeItem extends Component implements ComputeItem {

    @property({ type: 'string' })
    public name: string;

    @property({ type: 'string' })
    public value: string;

    @property({ type: 'string' })
    public message: string;
}
